module.exports = __webpack_public_path__ + "media/images/new/ad_free_experience-5197143f928acbf79539281d6e44a355.jpg";